<?xml version="1.0" encoding="utf-8"?>
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="-562.76 -943.492 720.846 1213.548"
>
  <path
    fill="#c87111"
    d="M -532.645 270.056 L -475.9 270.056 L -410.122 -312.94 L -465.989 -312.94 L -532.645 270.056 Z"
  />
  <path
    fill="#c87111"
    d="M 68.865 268.056 L 124.371 270.056 L 59.82 -312.94 L 0 -312.94 L 68.865 268.056 Z"
  />
  <path
    fill="#bd690f"
    d="M -561.023 -312.94 L 158.086 -312.94 L 154.796 -361.807 L -562.667 -362.629 L -561.023 -312.94 Z"
  />
  <path
    fill="#bd690f"
    d="M -453.946 75.135 L 46.504 75.868 L 41.443 34.768 L -449.46 35.448 L -453.946 75.135 Z"
  />
  <path
    fill="#aa5c0c"
    d="M -445.588 0.601 L -237.457 -157.151 L -412.717 -290.166 L -410.122 -312.94 L -368.126 -312.94 L -204.122 -182.003 L -36.595 -312.94 L 0 -312.94 L 3.165 -290.514 L -169.333 -158.396 L 37.147 0 L 42.094 35.017 L 14.759 35.017 L -204.125 -129.406 L -421.361 35.638 L -449.526 35.637 L -445.588 0.601 Z"
  />
  <path
    fill="#c87111"
    d="M -457.142 -362.151 L -403.37 -362.204 L -403.052 -686.629 L -457.615 -686.503 L -457.142 -362.151 Z"
  />
  <path
    fill="#c87111"
    d="M -1.449 -361.974 L 50.639 -361.813 L 50.639 -687.447 L -3.228 -687.123 L -1.449 -361.974 Z"
  />
  <path
    fill="#aa5c0c"
    d="M -521.488 -362.533 L -521.097 -419.736 L -326.15 -419.908 L -326.341 -362.342 L -293.757 -361.683 L -293.785 -419.813 L -113.381 -419.985 L -113.313 -362.028 L -81.502 -361.646 L -81.53 -419.708 L 114.408 -419.794 L 114.78 -361.77 L 147.774 -361.292 L 147.746 -512.291 L 114.78 -512.405 L 114.568 -452.856 L -81.063 -453.158 L -81.339 -512.31 L -113.132 -511.814 L -113.43 -453.244 L -294.157 -452.683 L -294.481 -512.691 L -326.837 -512.281 L -326.171 -453.002 L -521.097 -452.807 L -521.069 -512.996 L -554.177 -512.701 L -554.472 -362.265 L -521.488 -362.533 Z"
  />
  <path
    fill="#d37a14"
    d="M -562.285 -511.787 L 155.744 -511.662 L 156.115 -546.645 L -562.76 -546.975 L -562.285 -511.787 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M -537.647 -686.228 L 131.467 -686.718 L 130.977 -721.999 L -203.951 -943.492 L -537.162 -722.25 L -537.647 -686.228 Z"
  />
  <path
    data-player="true"
    fill="#666666"
    d="M -537.65 -686.228 L 131.468 -686.718 L 130.981 -722.002 L -537.177 -722.246 L -537.65 -686.228 Z"
  />
  <path
    fill="#ec9020"
    d="M -281.945 269.628 L -257.682 269.507 L -258.02 -385.257 L -281.934 -385.257 L -281.945 269.628 Z"
  />
  <path
    fill="#ec9020"
    d="M -148.667 268.955 L -124.53 269.288 L -124.637 -385.478 L -149.232 -385.258 L -148.667 268.955 Z"
  />
  <path
    fill="#e68b19"
    d="M -258.19 -317.91 L -148.97 -318.05 L -148.93 -339.33 L -258.22 -339.39 L -258.19 -317.91 Z M -258.12 -246.98 L -148.9 -247.12 L -148.86 -268.4 L -258.15 -268.46 L -258.12 -246.98 Z M -258.21 -176.13 L -148.98 -176.27 L -148.94 -197.55 L -258.24 -197.61 L -258.21 -176.13 Z M -258.05 -103.53 L -148.82 -103.67 L -148.78 -124.95 L -258.08 -125.01 L -258.05 -103.53 Z M -257.96 -34.922 L -148.74 -35.061 L -148.7 -56.341 L -257.99 -56.402 L -257.96 -34.922 Z M -258.04 36.538 L -148.81 36.399 L -148.78 15.119 L -258.07 15.058 L -258.04 36.538 Z M -257.88 107.132 L -148.65 106.993 L -148.62 85.713 L -257.91 85.652 L -257.88 107.132 Z M -257.73 177.332 L -148.5 177.193 L -148.46 155.913 L -257.76 155.852 L -257.73 177.332 Z M -257.85 249.355 L -148.62 249.216 L -148.59 227.936 L -257.88 227.875 L -257.85 249.355 Z"
  />
</svg>
